/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateOptionScoreItemDataSchema = z.object({
	questionId: z.string().uuid(),
	optionId: z.string(),
	scoreValue: z.number(),
})

export type UpdateOptionScoreItemDataSchema = z.infer<typeof updateOptionScoreItemDataSchema>
